import React from 'react';
import { StyleSheet, View } from 'react-native';
import { SafeAreaView } from 'react-native-safe-area-context';
import {
  Button,
  ModalFooter,
  ScrollViewWithHeaderTitle,
  theme,
  useBreakpointHelpers,
} from '@sg/garnish';

import { AppFooter } from '../../components/AppFooter';
import type { SweetpassUpgradeScreenPalette } from './SweetgreenUpgradeScreenPalette';
import { SweetpassUpgradeInnerContent } from './SweetpassUpgradeInnerContent';
import type {
  SweetpassUpgradeCtaHandler,
  SweetpassUpgradePage,
} from './SweetpassUpgradeScreen.loaded';

export type SweetpassUpgradeScreenContentProps = {
  readonly testID: string;
  readonly palette: SweetpassUpgradeScreenPalette;
  readonly content: SweetpassUpgradePage;
  readonly ctaHandler: SweetpassUpgradeCtaHandler;
};

export const SweetpassUpgradeScreenContent = ({
  testID,
  palette,
  content,
  ctaHandler,
}: SweetpassUpgradeScreenContentProps) => {
  const { isMobile } = useBreakpointHelpers();

  const handlePressCta = React.useCallback(() => {
    ctaHandler(content.cta.action);
  }, [ctaHandler, content]);

  return (
    <>
      <ScrollViewWithHeaderTitle
        testID="sweetpass.root.container"
        style={styles.scrollContainer}
        contentContainerStyle={styles.scrollContent}
        borderBottomColor={theme.colors.KALE}
        bounces={false}
      >
        <View testID={testID}>
          {content.content.map((contentItem) => (
            <SweetpassUpgradeInnerContent
              key={contentItem.id}
              content={contentItem}
              palette={palette}
              ctaHandler={ctaHandler}
            />
          ))}
        </View>
        {!isMobile ? (
          <View style={styles.footerCta}>
            <Button
              style={styles.cta}
              testID="sweetpass.upgrade-bottom-cta"
              palette={palette.ctaPalette}
              onPress={handlePressCta}
              size="xlarge"
            >
              {content.cta.title}
            </Button>
          </View>
        ) : null}
        {isMobile ? null : <AppFooter />}
      </ScrollViewWithHeaderTitle>

      {isMobile ? (
        <SafeAreaView edges={['bottom']}>
          <ModalFooter>
            <Button
              testID="sweetpass.upgrade-sticky-cta"
              palette={palette.ctaPalette}
              onPress={handlePressCta}
            >
              {content.cta.title}
            </Button>
          </ModalFooter>
        </SafeAreaView>
      ) : null}
    </>
  );
};

// ────────────────────────────────────────────────────────────────────────────────

const styles = StyleSheet.create({
  scrollContainer: {
    backgroundColor: theme.colors.KHAKI_3,
  },
  scrollContent: {
    flexGrow: 1,
  },
  footerCta: {
    alignItems: 'center',
    paddingBottom: 140,
  },
  cta: {
    minWidth: 520,
  },
});
